<template>
  <v-container
    id="set_modello"
  >
    <template>
      <!-- ################### SCELTA MODELLO E CALIBRO ############################### -->
      <v-row>
        <v-col
          class="  text-no-wrap"
        >
          <v-row
            no-gutters
            align="start"
          >
            <v-img
              :src="lens.desmod!='NN' ? `./img/FRM/${lens.desmod}.png` : './img/noimage.jpg'"
              :lazy-src="'./img/noimage.jpg'"
              max-width="90"
              contain
              class="mb-2 mr-2 pa-0"
            />
            <v-text-field
              v-model="lens.desmod"
              label="Cod. modello"
              outlined
              readonly
              :rules="[rules.required]"
              required
              @click="showForme = true;"
            />
          </v-row>
        </v-col>
        <v-col
          class="  text-no-wrap"
        >
          <v-select
            ref="calibro"
            v-model="lens.calibr"
            :items="rangeCalibro"
            :disabled="!lens.desmod"
            label="Calibro"
            :outlined="!!lens.desmod"
            :rules="!!lens.desmod ? [rules.required] : []"
          />
        </v-col>
        <v-col
          class="  text-no-wrap"
        >
          <!-- <v-select
            v-if="order.monsmo!='S'"
            ref="fornitura_lente"
            v-model="lens.fornitura_lente"
            class="ma-0"
            :items="lenssupplier"
            item-text="title"
            return-object
            :disabled="lens.d_filtro && lens.s_filtro"
            label="Modalità Ordine Lenti"
            :outlined="!(lens.d_filtro && lens.s_filtro)"
            :rules="((lens.d_filtro && lens.s_filtro) || lens.lendor=='CC') ? []:[rules.required] "
            clearable
            @change="$set(lens,'diamet',null);"
          />
          <v-text-field
            v-if="!(lens.d_filtro && lens.s_filtro) && lens.fornitura_lente?.value=='diametro'"
            ref="diametro_lente"
            v-model="lens.diamet"
            class="ma-0"
            dense
            reverse
            label="Diametro"
            outlined
            :rules="!(lens.d_filtro && lens.s_filtro) ? [rules.required] : []"
            @input="setDiamet"
          /> -->

          <v-text-field

            ref="fornitura_lente"
            v-model="lens.fornitura_lente"
            class="ma-0"
            dense
            reverse
            label="Modalità Ordine Lenti"
            outlined
            readonly
          />
        </v-col>
      </v-row>
      <v-row
        v-if="nolens"
        class="ma-0 blue--text"
        style="margin:-25px 0 0 0 !important;"
        @click="showForme=true"
      >
        <v-col
          cols="auto"
          style="cursor:pointer"
        >
          <v-icon>mdi-message-bulleted</v-icon> {{ lens.nolens_detail }}
        </v-col>
      </v-row>
      <!-- <v-btn @click="$refs.formlenti.validate()">
          Validazione
        </v-btn> -->
    </template>
    <v-dialog
      v-model="showForme"
      scrollable
      max-width="800"
    >
      <v-card>
        <v-col>
          <v-row no-gutters>
            <span class="text-h2 font-weight-light">Modello/Forma Lenti </span>
            <v-spacer />
            <v-btn
              v-if="!nolens"
              x-small
              fab
              @click="showForme = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-divider />
        <v-card-subtitle>
          <v-col cols="12">
            <v-checkbox
              v-model="nolens"
              label="lente non in elenco"
              @change="setDesmod"
            >
              <template v-slot:label>
                <span :class="nolens?'text-h3 font-weight-light black--text':'text-h3 font-weight-light grey--text'">Lente non in elenco</span>
              </template>
            </v-checkbox>
            <v-row v-if="nolens">
              <v-col cols="12">
                <v-textarea
                  v-model="lens.nolens_detail"
                  outlined
                  label="Descrizione caratteristiche e dettagli lente"
                />
              </v-col>
            </v-row>
            <v-text-field
              v-if="!nolens"
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca"
              placeholder="cerca modello lente"
              single-line
              hide-details
              outlined
            />
          </v-col>
        </v-card-subtitle>

        <v-card-text>
          <!-- {{ listalenti }} -->
          <v-data-table
            v-if="!nolens"
            fixed-header
            mobile-breakpoint="0"
            disable-pagination
            hide-default-footer
            dense
            :items="listalenti"
            :headers="headers"
            :search="search"
            item-key="id"
            @click:row="lensClick"
          >
            <template
              v-slot:item.modello="{item}"
            >
              <span class="text-h2 font-weight-light">{{ item.modello }}</span>
            </template>
            <template
              v-slot:item.forma="{item}"
            >
              <v-img
                :src="`./img/FRM/${item.modello}.png`"
                :lazy-src="'./img/noimage.jpg'"
                max-width="150"
                contain
                class="ma-2"
              />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions v-if="nolens">
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="lens.nolens_detail=null; nolens = false"
          >
            Annulla
          </v-btn>
          <v-btn
            color="primary"
            :disabled="lens.nolens_detail==null || lens.nolens_detail.trim()==''"

            @click="showForme = false"
          >
            Conferma
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'SceltaLenti',
    components: {

    },
    props: {
      alive: {
        type: Boolean,
        default: false,
      },
      order: {
        type: Object,
        default: () => {},
      },
      lens: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        loading: false,
        cliente: null,
        validForm: false,
        // lens: { nolens_detail: null },
        procedura: {},
        nolens: false,
        dittalenti: [],
        listalenti: [],
        listapromo: [],
        rangeCalibro: [],
        lenssupplier: [
          { title: 'A magazzino', value: 'magazzino' },
          { title: 'Invio disegno per costruzione/precalibratura', value: 'disegno' },
          { title: 'Lenti non precalibrate o spessorate', value: 'diametro' },
        ],

        headers: [
          { text: '', value: 'modello', align: 'right text-caption', width: '30%' },
          { text: '', value: 'forma', align: 'left text-caption', sortable: false },

        ],
        search: '',
        showForme: false,
        rules: {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
          signed: v => (!v || /^[+-]\d*\.?\d*$/.test(v)) || 'E` richiesto il segno + o -',
          range: (min, max) => (v) => {
            if (!v) {
              return true
            }
            var num = parseFloat(v)
            return (num >= min && num <= max) || `Richiesto valore tra ${min} e ${max}`
          },
          // stepper: (step) => (v) => {
          //   if (!v) {
          //     return true
          //   }
          //   var num = parseFloat(v)
          //   var tolerance = 0.01
          //   if (step === 0.25) {
          //     tolerance = 0.009
          //   }

          //   var valore = Math.abs(num % step).toFixed(10)
          //   console.log(num, step, valore)
          //   if (valore < tolerance) {
          //     valore = 0
          //   }
          //   // console.log(40 % 0.01)
          //   // due to floating-point precision issues, the result is not exactly zero
          //   return (valore === 0) || `Richiesto multiplo di ${step}`
          // },

          stepper: (step) => (v) => {
            if (!v) {
              return true
            }

            // Scale factor const scale = 100; // Multiply var to convert it to an integer
            var num = parseFloat(v) * 100
            var stp = step * 100

            var valore = ((Math.abs(num % stp)) / 100).toFixed(2)

            return (+valore === 0) || `Richiesto multiplo di ${step}`
          },
          requiredOn: (field) => (v) => {
            if (this.$refs[field] && this.$refs[field]?.value) {
              return !!v || `Richiesto un valore perchè ${field.substr(3).toUpperCase()} non e' vuoto`
            }
            return true
          },
          requiredIf: (vero) => (v) => {
            if (vero) {
              return !!v || 'Valore richiesto'
            }
            return true
          },
        },
        menu_data_lenti: false,
        dataord_lenti: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

      }
    },
    computed: {
      ...mapState(['auth', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      config () {
        return Config
      },

    },
    watch: {
      // order: {
      //   handler (newval) {
      //     if (this.alive && this.order.lens) { this.lens = JSON.parse(JSON.stringify(this.order.lens)) }
      //   },
      //   deep: true,
      // },
      // lens: {
      //   handler (newval) {
      //     this.validate()
      //     console.log('lens', newval, this.$refs.formlenti.validate())
      //     this.$nextTick(() => {
      //       if (newval && this.lens.desmod && this.$refs.formlenti.validate()) {
      //         console.log('EMIT LENSCOMPLETE')
      //         this.$emit('lensComplete', this.lens)
      //       } else {
      //         this.$emit('lensComplete', false)
      //       }
      //     })
      //   },
      //   deep: true,
      // },

      // monpro (newval, oldval) {
      //   if (newval.length === 1) {
      //     this.lens.monpro = newval[0]
      //   }
      // },

      // order (newval) {
      //   this.lens = JSON.parse(JSON.stringify(this.order.lens))
      // },
      lens (newval) {
        console.log('lenschanged', newval)
        if (newval.fornitura_lente !== 'magazzino') {
          this.$set(this.lens, 'fornitura_lente', 'magazzino')
        }
      },
    },
    mounted () {
      console.log('mount setmodello', this.lens)

      this.load_listalenti()
      this.load_listapromo()

      // if (this.order.lens) { this.lens = JSON.parse(JSON.stringify(this.order.lens)) }
      // if (this.lens.desmod !== '') { this.lensClick({ init: true, modello: this.lens.desmod, calibro: this.lens.calibr }) }
      // if (this.lens.desmod === 'NN') { this.nolens = true }
    },
    beforeDestroy () {

    },
    methods: {
      ftDecimal (campo, fix = 2) {
        var valore = this.lens[campo]
        console.log('ftDecimal', campo, valore)
        var newval = null
        if (!valore || valore.trim() === '' || isNaN(parseFloat(valore))) {
          newval = null
        } else if (valore >= 0 && !['d_semidi', 's_semidi', 'd_altezz', 's_altezz'].includes(campo)) {
          newval = '+' + parseFloat(valore).toFixed(fix)
        } else {
          newval = parseFloat(valore).toFixed(fix)
        }

        this.lens[campo] = newval
      },
      validate () {
        this.$refs.formlenti.validate()
      },
      reset () {
        this.$refs.formlenti.reset()
      },
      resetValidation () {
        this.$refs.formlenti.resetValidation()
      },

      load_listalenti () {
        this.loading = true
        engine.get_listalenti(this.$linea().label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.listalenti = result.data
          })
          .catch((errore) => {
            console.log('get_listalenti err: ', errore)
          }).finally(() => { this.loading = false })
      },
      load_listapromo () {
        this.loading = true
        engine.get_listapromo(this.$linea().label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.listapromo = result.data
          })
          .catch((errore) => {
            console.log('get_listapromo err: ', errore)
          }).finally(() => { this.loading = false })
      },
      lensClick (item) {
        if (this.$linea().label === 'JOY') {
          this.$set(this.lens, 'desmod', item.modello)
          this.rangeCalibro = item.calibro?.split(',')
        } else if (this.$linea().label === 'JOYBAB') {
          this.$set(this.lens, 'desmod', item.modello)
          this.rangeCalibro = item.calibro?.split(',')
        } else {
          // linea: SWF
          this.$set(this.lens, 'desmod', item.modello)
          // this.setRangeCalibro(item.calibro)
          this.rangeCalibro = [44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63]
        }
        this.$set(this.lens, 'calibr', null)
        if (item.init) { this.$set(this.lens, 'calibr', item.calibro) }
        this.$forceUpdate()
        this.showForme = false
      },
      setDesmod () {
        if (this.nolens) {
          this.$set(this.lens, 'desmod', 'NN')
          if (this.$linea().label === 'JOY') {
            this.rangeCalibro = ['XS', 'S', 'M', 'L', 'XL', 'XXL']
          } else if (this.$linea().label === 'JOYBAB') {
            // linea JOYBABY
            this.rangeCalibro = ['XS', 'S']
          } else {
            // linea SWF
            this.rangeCalibro = [46, 47, 48, 49, 50, 51, 52, 53, 54]
          }
          this.$set(this.lens, 'calibr', null)
        } else {
          this.$set(this.lens, 'desmod', null)
        }
      },
      setTipTrt (item) {
        console.log('setTipTrt', item)
        if (!item) {
          item = { tipoLente: null, trtLente: null }
        }
        this.$set(this.lens, 's_destip', item.tipoLente)
        this.$set(this.lens, 'd_destip', item.tipoLente)
        this.$set(this.lens, 's_destrt', item.trtLente)
        this.$set(this.lens, 'd_destrt', item.trtLente)
      },
      setRangeCalibro (calibro) {
        // creo range di -4, +4 a partire dal calibro base
        this.rangeCalibro = Array.from({ length: 9 }, (_, index) => parseInt(calibro) - 4 + index)
      },
      setDistan () {
        this.$set(this.lens, 'distan', (+(this.lens.d_semidi ?? 0) + +(this.lens.s_semidi ?? 0)).toFixed(1))
      },
      setFilter (pos) {
        this.setDistan()

        if (pos === 'OD' && this.lens.d_filtro) {
          this.$set(this.lens, 'd_vsfero', null)
          this.$set(this.lens, 'd_cilind', null)
          this.$set(this.lens, 'd_vlasse', null)
          this.$set(this.lens, 'd_addizi', null)
          this.$set(this.lens, 'd_prisma', null)
          this.$set(this.lens, 'd_vgradi', null)
          this.$set(this.lens, 'd_semidi', null)
          this.$set(this.lens, 'd_altezz', null)
        }

        if (pos === 'OS' && this.lens.s_filtro) {
          this.$set(this.lens, 's_vsfero', null)
          this.$set(this.lens, 's_cilind', null)
          this.$set(this.lens, 's_vlasse', null)
          this.$set(this.lens, 's_addizi', null)
          this.$set(this.lens, 's_prisma', null)
          this.$set(this.lens, 's_vgradi', null)
          this.$set(this.lens, 's_semidi', null)
          this.$set(this.lens, 's_altezz', null)
          this.$set(this.lens, 'tabint', null)
        }

        if (this.lens.d_filtro && this.lens.s_filtro) {
          // this.lens.fornitura_lente = null per HERZACH vale sempre magazzino
          this.$set(this.lens, 'distan', null)
        }
        // ricalcolo DI

        this.$nextTick(() => {
          this.validate()
        })
      },
      setDittaLente (smarca) {
        console.log('setDittaLente', smarca, this.dittalenti)
        const item = this.dittalenti.find((item) => item.marca === smarca)
        this.$set(this.lens, 'identi', item?.idcode)
        this.$set(this.lens, 'altra_ditta_lenti', item?.ditta || smarca)
        if (smarca === 'AL') {
          this.$set(this.lens, 'altra_ditta_lenti', null)
        }
        this.$forceUpdate()
      },
      setDiamet (value) {
        this.$set(this.lens, 'diamet', value); this.validate(); this.$forceUpdate()
      },
      changeLendor (newVal) {
        console.log('lendornewVal', newVal)

        this.$set(this.lens, 'smarca', null)
        this.$set(this.lens, 'monpro', null)
        this.$set(this.lens, 'tiptrt', null)

        if (newVal === 'PD') {
          if (this.marcheLenti.length === 1) {
            this.$set(this.lens, 'smarca', this.marcheLenti[0].marca)
            this.setDittaLente(this.marcheLenti[0].marca)
          }
          if (this.monpro.length === 1) {
            this.$set(this.lens, 'monpro', this.monpro[0])
          }
        }
        this.setTipTrt(false)
      },
      // onSubmit () {
      //   this.valid = this.$refs.form.validate()
      //   if (this.valid) {
      //     console.log('send', this.lens)
      //     const data = { lens: this.lens, cliente: this.cliente }
      //     engine.sendRiparazione(data).then((result) => {
      //       if (result) {
      //         // alert('Form has been submitted!')
      //         console.log('sendRiparazione', result)
      //         this.$store.commit('setSnack', { message: 'Inviato ordine di riparazione', color: '#4caf50', timeout: 5000 })
      //       }
      //     })
      //       .catch((errore) => {
      //         // eslint-disable-next-line no-console
      //         console.error('ERR####', errore)
      //       })
      //     return
      //   }
      //   this.$store.commit('setSnack', { message: 'Inserire Dati Obbligatori', color: '#c54747d4', timeout: 8000 })
      //   this.$vuetify.goTo(0) // scroll top
      //   console.log('send invadlid', this.lens)
      // },
    },
  }

</script>
